import "./MultiAccountOrderStep.scss";
import template from "./MultiAccountOrderStep.html";
import {IComponentOptions} from "angular";
import {isNotNull} from "../../../../../../js/util/UtilFunctions";
import {ReplaySubject} from "rxjs";
import {MultiOrderStore} from "../../store/MultiOrderStore";
import {EquityWizardData} from "../../../place-equity-order-wizard/models/EquityWizardData";
import {MultiAccountOrdersDialogService} from "../../../multi-equity-ticket/MultiAccountOrdersDialogService";
import {take} from "rxjs/operators";

export const MultiAccountOrderStep = "tfMultiAccountOrdersStep";

export function multiAccountOrdersStep(): IComponentOptions {
    return {
        template,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: MultiAccountOrdersStepController
    };
}

export class MultiAccountOrdersStepController {

    /** @input */
    public readonly store: MultiOrderStore;
    public readonly singleAccountOrders$ = new ReplaySubject<Array<EquityWizardData>>(1);
    public readonly firstAccountOrder$ = new ReplaySubject<EquityWizardData>(1);
    private readonly destroyed$ = new ReplaySubject<boolean>(1);
    /** @ngInject */
    public constructor(private readonly multiAccountOrderDialogService: MultiAccountOrdersDialogService) {
    }
    public openAddChildOrderModal() {
        this.store
            .orders$
            .pipe(take(1))
            .map((d) => d)
            .filter(isNotNull)
            .distinctUntilChanged()
            .subscribe((orders) => {
                if (orders.length > 0) {
                    this.multiAccountOrderDialogService.openSingleAccountDialog(this.store, {
                        code: orders[0].code,
                        exchange: orders[0].exchange,
                    }, null);
                } else {
                    this.multiAccountOrderDialogService.openSingleAccountDialog(this.store, null, null);
                }
            });

    }
    public openEditChildOrderModal(singleOrder: EquityWizardData, index: number | null) {
        this.multiAccountOrderDialogService.openSingleAccountDialog(this.store, singleOrder, index);
    }

    public $onInit(): void {
        this.watchSingleAccountOrders();
        this.watchFirstAccountOrder();
    }
    public removeOrder(index: number) {
        this.store.removeOrder(index);
    }

    private watchSingleAccountOrders() {
        this.store
            .orders$
            .takeUntil(this.destroyed$)
            .map((d) => d)
            .filter(isNotNull)
            .distinctUntilChanged()
            .subscribe((orders) => this.singleAccountOrders$.next(orders));
    }

    private watchFirstAccountOrder() {
        this.store
            .orders$
            .takeUntil(this.destroyed$)
            .map((d) => d)
            .filter(isNotNull)
            .distinctUntilChanged()
            .subscribe((orders) => this.firstAccountOrder$.next(orders[0]));
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
